import TodoItem from "./todo-item";

export default class Todo {
    constructor(
        data={
            id:-1,
            title:'',
            items:[],
        }
    ) {
        this.id = data.id;
        this.title = data.title;
        this.items = []

        if ( data.items ) {
            this.createItems(data.items);
        }
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.title;
    }

    getItems() {
        return this.items;
    }

    addItem(toDoItem=undefined) {
        if ( toDoItem !== undefined ) {
            this.items.push(toDoItem);
        }
    }

    addNewItem(toDoItem=undefined) {
        if ( toDoItem !== undefined ) {
            this.items.unshift(toDoItem);
        }
    }

    createItems(items=[]) {
        items.forEach(data => {
            const toDoItem = new TodoItem(data);
            this.addItem(toDoItem);
        });
    }

    hasItems() {
        return this.items.length > 0;
    }

    deleteItem(id=-1) {
        if ( id !== -1 ) {
            this.items = this.items.filter(item => item.id !== id);
        }
    }

    getItemById(id=-1) {
        if ( id !== -1 ) {
            const itemIndex = this.getItemIndexById(id);

            if ( itemIndex !== -1 ) {
                return this.items[itemIndex];
            }

            return false;
        }

        return false;
    }

    getItemIndexById(id=-1) {
        if ( id !== -1 ) {
            return this.items.map( (e) => {  return e.id; } ).indexOf(id);
        }
        return -1;
    }

    getItemIds() {
        const ids = [];

        this.items.forEach(item => {
            ids.push(item.id);
        });
        
        return ids;
    }

    toFormObject() {
        return {
            id: this.id,
            title: this.title,
            item_ids: this.getItemIds(),
        };
    }

    markItemDone(id=-1) {
        if ( id === -1 ) {
            return false;
        }
        const index = this.getItemIndexById(id);
        const item = this.items[index];

        item.toggleDoneState();
        this.items[index] = item;

        return true;
    }
}
